import { Outlet } from 'react-router-dom';
import { Header } from '../Header';
import { useTheme } from '@/features/theme/contexts/ThemeContext';

export default function Layout() {
  const { theme } = useTheme();
  
  return (
    <div data-theme={theme} className="min-h-screen w-full flex flex-col bg-dark">
      <Header />
      <main className="flex-1 flex flex-col w-full overflow-x-hidden overflow-y-auto">
        <Outlet />
      </main>
    </div>
  );
}
